import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getSystemPOsWithNonPendingInvoicesOlderThan6Months = async () => {
  try {
    const response = await apiClient.get(
      '/systemInvoiceManagement/workflow/pos-with-non-pending-invoices-older-than-6-months'
    );
    if (response.data?.response && Array.isArray(response.data.response)) {
      return response.data.response;
    }
    return response.data?.response || response.data || [];
  } catch (error) {
    handleApiError(error);
    return [];
  }
};
